import React, { useState } from 'react';
import { Button, Form, Header, InputOnChangeData, Segment } from 'semantic-ui-react';
import { IEmailVerification } from '../../../types/auth';

interface Props {
  sendEmail: (mail: IEmailVerification) => void;
  resetPassword: (route: string) => void;
}

export const ForgetPasswordEmail = (props: Props): JSX.Element => {

  const [email, setEmail] = useState<IEmailVerification>({
    email: ''
  })

  const handleBack = () => {
    props.resetPassword('/login')
  }

  const handleChangeEmail = (data: InputOnChangeData) => {
    const _email = { ...email, email: data.value }
    setEmail(_email)
  }

  const handleRequestEmail = () => {
    props.sendEmail(email)
  }

  return (
    <Segment style={{ border: 'none', background: 'white', height: '38rem', width: '39.3rem', borderRadius: '8px', boxShadow: '0 0 25px -5px rgba(21,21,21,0.1)' }}>
      <Header textAlign='left' style={{ padding: '3rem', fontSize: '2.5rem' }}>
        Email request
        <Header.Subheader style={{ color: '#BEC8C3', fontSize: '1.125rem', marginTop: '1rem' }}>Please enter your email to proceed.</Header.Subheader>
      </Header>
      <Form size='large' style={{ textAlign: 'left', padding: '0 3rem 3rem 3rem' }}>
        <label style={{ fontWeight: 500, textAlign: 'left', color: '#747678', fontSize: '1.125rem', paddingBottom: '1rem' }}>User Email</label>
        <Form.Input
          labelPosition='left'
          style={{ borderRadius: '8px', marginTop: '1rem' }}
          fluid={true}
          icon='mail'
          size='large'
          iconPosition='left'
          placeholder='Email'
          onChange={(e, data) => { handleChangeEmail(data) }}
        />
        <Button
          primary
          fluid
          onClick={() => handleRequestEmail()}
          content='Send request'
          style={{ marginTop: '2rem', height: '50px', borderRadius: '8px', padding: 0, fontSize: '18px', lineHeight: '21px', letterSpacing: '0.25px' }}
        />
        <Button
          color='purple'
          fluid
          onClick={() => handleBack()}
          content='Back'
          style={{ marginTop: '2rem', height: '50px', borderRadius: '8px', padding: 0, fontSize: '18px', lineHeight: '21px', letterSpacing: '0.25px' }}
        />
      </Form>
    </Segment>
  )
}

export default ForgetPasswordEmail
